import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListBoxComponent } from './listbox.component';
/**
 * NgModule definition for the ListBox component.
 */
export class ListBoxModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [
        ListBoxComponent
    ],
    exports: [
        ListBoxComponent
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ListBoxModule_tsickle_Closure_declarations() {
/** @type {?} */
ListBoxModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ListBoxModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
